import _ from "lodash";
import { useMemo } from "react";

export default function useEmployeeDetails() {
  const employeeDetails = JSON.parse(localStorage.getItem("employeeDetails"));

  const employeeName = useMemo(() => {
    return _.get(employeeDetails, "name");
  }, [employeeDetails]);

  const employeeEmail = useMemo(() => {
    return _.get(employeeDetails, "email");
  }, [employeeDetails]);

  const employeePhoneNumber = useMemo(() => {
    return _.get(employeeDetails, "phone");
  }, [employeeDetails]);

  const employeeToken = useMemo(() => {
    return _.get(employeeDetails, "token");
  }, [employeeDetails]);

  const id = useMemo(() => {
    return _.get(employeeDetails, "_id");
  }, [employeeDetails]);

  const employeeId = useMemo(() => {
    return _.get(employeeDetails, "emp_id");
  }, [employeeDetails]);

  const employeeDesignation = useMemo(() => {
    return _.get(employeeDetails, "designation");
  }, [employeeDetails]);

  const employeeDepartment = useMemo(() => {
    return _.get(employeeDetails, "designation");
  }, [employeeDetails]);

  return {
    employeeName,
    employeePhoneNumber,
    employeeToken,
    id,
    employeeId,
    employeeEmail,
    employeeDesignation,
    employeeDepartment
  };
}
